import { tw } from "@careinfo/tailwind";
import moment from "moment";
import { toTitleCaseWithSpace } from "../../../utils";
import APIS from "../../../constant/Endpoint";
import { getApiData } from "../../../helpers/AxiosInstance";

export default function ({
  user,
  old_data,
  new_data,
  created,
  extra_data,
  branch,
  field_name,
}) {
  const updatedFieldKeys = extra_data?.updated_fields
    ? Object.keys(extra_data?.updated_fields)
    : [];

  const domainName = window.location.hostname;

  const SERVICE_MAP: Record<string, { url: string; service: string }> = {
    dispatch_manifest: {
      url: APIS.DISPATCH_MANIFEST,
      service: "dispatch-manifest",
    },
    receive_manifest: {
      url: APIS.RECEIVE_MANIFEST,
      service: "receive-manifest",
    },
    pickup_request: {
      url: APIS.PICKUP_REQUEST,
      service: "courier-pickup-request",
    },
    runsheet: { url: APIS.RUNSHEET, service: "runsheet" },
    rtv_order: { url: APIS.RTV_ORDER, service: "return-orders" },
    rtv_branch: { url: APIS.RTV_BRANCH, service: "return-branch" },
    rider_invoice: {
      url: APIS.RIDER_INVOICE,
      service: "finance-rider-invoice",
    },
    branch_invoice: {
      url: APIS.BRANCH_INVOICE,
      service: "finance-branch-invoice",
    },
    merchant_invoice: {
      url: APIS.MERCHANT_INVOICE,
      service: "finance-merchant-invoice",
    },
    vehicle_manifest: {
      url: APIS.VEHICLE_MANIFEST,
      service: "vehicle-manifest",
    },
  };

  const INVOICE_TYPES = new Set([
    "rider_invoice",
    "branch_invoice",
    "merchant_invoice",
  ]);

  const handleGetDetails = async (type: string, value: string) => {
    const config = SERVICE_MAP[type];
    if (!config) {
      console.warn("Unknown type:", type);
      return;
    }
    try {
      const res = await getApiData(config.url, {
        limit: 1,
        offset: 0,
        search: value,
      });

      if (res?.status === 200) {
        const id = res?.data?.results?.[0]?.id;
        if (!id) return;

        const mode = INVOICE_TYPES.has(type) ? "preview" : "edit";
        const url = `https://${domainName}/${config.service}#/${mode}/${id}`;
        window.location.replace(url);
      }
    } catch (err) {
      console.error("Error fetching details:", err);
    }
  };

  return (
    <div className={tw`border-b-2 border-gray-200 py-4  text-sm space-y-2`}>
      <div className={tw`flex items-center justify-start gap-x-3`}>
        {user?.name && (
          <h5>
            <span className={tw`text-primary font-medium capitalize`}>
              {user?.name}{" "}
            </span>
            has made changes
          </h5>
        )}

        <p className={tw`text-gray-500`}>
          {extra_data?.date
            ? moment(extra_data?.date).format("YY-MM-DD h:mm:ss A")
            : moment(created).format("YY-MM-DD h:mm:ss A")}
        </p>
      </div>
      <div className={tw`flex  justify-start gap-x-3`}>
        <p>{toTitleCaseWithSpace(field_name)}:</p>
        <p>
          {old_data && (
            <>
              <span className={tw`px-2 py-1 bg-gray-500 text-white rounded-sm`}>
                {old_data}
              </span>{" "}
              -&gt;{" "}
            </>
          )}
          {new_data && (
            <span
              className={tw`px-2 py-1 bg-primary text-white rounded-sm whitespace-nowrap`}
            >
              {new_data}
            </span>
          )}
          {extra_data && field_name !== "delivery_status" && (
            <>
              <span
                className={tw`px-2 py-1 bg-primary text-white rounded-sm whitespace-nowrap`}
              >
                {extra_data?.comment}, {branch?.name},{" "}
                {extra_data?.phone_number}
              </span>
              <br />
              {extra_data?.tracking_number ? (
                <span className={tw`capitalize`}>
                  {field_name}:{" "}
                  <button
                    className={tw`focus:outline-none hover:underline hover:text-primary`}
                    onClick={() =>
                      handleGetDetails(field_name, extra_data.tracking_number)
                    }
                  >
                    {extra_data?.tracking_number}
                  </button>
                </span>
              ) : null}
              {extra_data?.reason ? (
                <span className={tw`capitalize`}>
                  Reason: {extra_data?.reason}
                </span>
              ) : null}
              {extra_data?.updated_fields
                ? updatedFieldKeys.length > 0 && (
                    <div className={tw`mt-1`}>
                      {Object.entries(extra_data.updated_fields)
                        .filter(
                          ([field]) =>
                            field !== "sender" &&
                            field !== "receiver" &&
                            field !== "is_removed"
                        )
                        .map(([field, values]: any, index) => (
                          <div key={index} className={tw`text-sm`}>
                            <p>
                              <span className={tw`font-semibold`}>
                                {toTitleCaseWithSpace(field)}:{" "}
                              </span>
                              <span className={tw`px-2 py-1 rounded-sm`}>
                                {values.old_value}
                              </span>{" "}
                              &rarr;{" "}
                              <span
                                className={tw`text-primary px-2 py-1 rounded-sm`}
                              >
                                {values.new_value}
                              </span>
                            </p>
                          </div>
                        ))}
                    </div>
                  )
                : null}
            </>
          )}
        </p>
      </div>
    </div>
  );
}
